/* @flow */
import React from 'react';

import cx from 'classnames';

import styles from './styles/AppLayoutContentView.css';

export default class AppLayoutContentView extends React.Component {
  static propTypes = {
    header: React.PropTypes.node,
    sidebar: React.PropTypes.node,
  };

  renderSidebarBlock() {
    const { header, sidebar } = this.props;

    return sidebar ? (
      <div className={styles.sidebar}>
        {header}
        {sidebar}
      </div>
    ) : null;
  }

  render() {
    return (
      <div className={cx(styles.this, this.props.className)}>
        {this.renderSidebarBlock()}
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/AppLayoutContentView.jsx